import { render, staticRenderFns } from "./UserRoleManager.vue?vue&type=template&id=fd4d6980&scoped=true&"
import script from "./UserRoleManager.vue?vue&type=script&lang=js&"
export * from "./UserRoleManager.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleManager.vue?vue&type=style&index=0&id=fd4d6980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4d6980",
  null
  
)

export default component.exports